<template>
  <div class="mt-4" v-if="canAccess">
    <div class="ibox">
      <div class="ibox-title">
        <span>Agendamento de consultas por frequência</span>
        <chevron-down-icon class="chevron-icon fa-angle-right" :class="{'rotate-90': section === 'byFrequency' }" @click="toggleSection('byFrequency')"/>
      </div>

      <div v-if="this.section === 'byFrequency'">
        <div class="ibox-content d-flex flex-row">
          <div class="form-group col-md-5">
            <label for="appointment-date">Selecione o(s) dia(s) da semana</label>
            <div>
              <button
                  v-for="day in daysOfWeek"
                  @click="toggleDaySelection(day)"
                  :key="day"
                  class="btn btn-sm btn-outline mr-2 mb-2"
                  :class="{'btn-outline-active': isSelected(day)}"
              >
                <strong>{{ day | uppercase }}</strong>
              </button>
            </div>
          </div>

          <div class="form-group col-md-2">
            <label for="appointment-time">Selecione um horário</label>
            <select id="appointment-time" v-model="selectedTime" class="form-control">
              <option v-for="hour in availableHours" :key="hour" :value="hour">{{ hour }}</option>
            </select>
          </div>
          <div class="form-group col-md-2">
            <label for="repeat">Frequência</label>
            <select id="repeat" v-model="repeat" class="form-control">
              <option value="weekly">Semanal</option>
              <option value="biweekly">Quinzenal</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="appointment-date">Até</label>
            <input type="date" id="appointment-date" v-model="endDate" class="form-control">
          </div>
        </div>

        <div class="form-group col-md-4 ml-3">
          <button
              class="btn btn-primary"
              :disabled="disableButton"
              @click="scheduleAppointment"
          >
            Agendar Consulta
          </button>
        </div>
      </div>
    </div>

    <div class="ibox">
      <div class="ibox-title">
        <span>Agendamento de consultas unitária</span>
        <chevron-down-icon class="chevron-icon fa-angle-right" :class="{'rotate-90': section === 'byUnitary' }" @click="toggleSection('byUnitary')"/>
      </div>

      <div v-if="this.section === 'byUnitary'">
        <div class="ibox-content d-flex flex-row">
          <div class="form-group col-md-2">
            <label for="appointment-time">Selecione um horário</label>
            <select id="appointment-time" v-model="selectedTime" class="form-control">
              <option v-for="hour in availableHours" :key="hour" :value="hour">{{ hour }}</option>
            </select>
          </div>

          <div class="form-group col-md-2">
            <label for="repeat">Selecione o dia</label>
            <input type="date" id="appointment-date" v-model="unitaryDate" class="form-control">
          </div>
          <div class="form-group col-md-4">
            <br>
            <button
                class="btn btn-primary"
                :disabled="disableButton"
                @click="scheduleAppointment"
            >
              agendar consulta
            </button>
          </div>
        </div>

      </div>
    </div>

    <EventSchedules :app-name="appName" :change="changeAmount"/>
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import GetAccount from '@/mixins/GetAccount.vue'
import GetUser from '@/mixins/GetUser.vue'
import EventSchedules from './EventSchedules.vue'
import { ChevronDownIcon } from 'vue-feather-icons'

const DAYS = {
  dom: 'sun',
  seg: 'mon',
  ter: 'tue',
  qua: 'wed',
  qui: 'thu',
  sex: 'fri',
  sab: 'sat'
}

const HOURS = {
  '00:00': 0,
  '01:00': 1,
  '02:00': 2,
  '03:00': 3,
  '04:00': 4,
  '05:00': 5,
  '06:00': 6,
  '07:00': 7,
  '08:00': 8,
  '09:00': 9,
  '10:00': 10,
  '11:00': 11,
  '12:00': 12,
  '13:00': 13,
  '14:00': 14,
  '15:00': 15,
  '16:00': 16,
  '17:00': 17,
  '18:00': 18,
  '19:00': 19,
  '20:00': 20,
  '21:00': 21,
  '22:00': 22,
  '23:00': 23
}

export default {
  components: { ChevronDownIcon, EventSchedules },
  computed: {
    canAccess() {
      return this.getUser?.brobotStaff || false
    },
    disableButton() {
      if (this.section == 'byFrequency')
        return !(this.selectedTime && this.endDate && this.selectedDaysOfWeek.length > 0)
      else
        return !(this.selectedTime && this.unitaryDate)
    }
  },
  created() {
    if (!this.canAccess) {
      const redirectPath = `/${this.appName.replace('_', '-')}`
      this.$router.push(redirectPath)
      return
    }

    this.initializeInputs()
  },
  data() {
    return {
      endDate: '',
      unitaryDate: '',
      selectedTime: '',
      repeat: null,
      daysOfWeek: ['seg', 'ter', 'qua', 'qui', 'sex', 'sab', 'dom'],
      selectedDaysOfWeek: [],
      availableHours: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
      nameModel: 'Schedule',
      showTicketHistories: false,
      changeAmount: 0,
      section: 'byFrequency'
    }
  },
  methods: {
    toggleDaySelection(day) {
      const index = this.selectedDaysOfWeek.indexOf(day);
      if (index > -1) {
        this.selectedDaysOfWeek.splice(index, 1);
      } else {
        this.selectedDaysOfWeek.push(day);
      }
    },
    isSelected(day) {
      return this.selectedDaysOfWeek.includes(day);
    },
    scheduleAppointment() {
      const schedule = {
        app_name: this.appName,
        days: this.selectedDaysOfWeek.map(day => DAYS[day]),
        hour: HOURS[this.selectedTime],
        frequency: this.repeat,
        end_date: this.endDate,
        unitary_date: this.section === 'byFrequency' ? null : this.unitaryDate
      }

      this.asyncTemplateSave(schedule, {
        after: () => {
          this.$notify.add('Consulta agendada com sucesso!')
          this.changeAmount++
        },
        finish: () => this.initializeInputs()
      })
    },
    initializeInputs() {
      const date = new Date(new Date().setFullYear(new Date().getFullYear() + 1))
      this.endDate = this.$utils.toDateInput(date)

      this.selectedDaysOfWeek = []
      this.selectedTime ||= '12:00'
      this.repeat = 'weekly'
    },
    toggleSection(value) {
      if (this.section === value)
        this.section = null 
      else
        this.section = value
    }
  },
  mixins: [ModelMapper, GetAccount, GetUser],
  name: 'Setting',
  props: {
    appName: { required: true, type: String}
  }
}
</script>

<style scoped>
#appointment-time {
  cursor: pointer;
}

.chevron-icon {
  cursor: pointer
}
</style>
